import React from "react";
import { Title, Text, Stack } from "@mantine/core";
import { PageProps } from "@sdflc/react-router-pages";

import { FullScreenLayout } from "../../../components/layouts";
import { Logo } from "@/components/generic";

export const ServerErrorPage: React.FC<PageProps> = (props: PageProps) => {
  return (
    <FullScreenLayout justify="center" align="center" {...props}>
      <Stack gap="xl" align="center" ta="center" maw={500} px="md">
        <Logo size="large" withName />

        <Text
          size="8rem"
          style={{
            lineHeight: 1,
          }}
        >
          🔧
        </Text>

        <Stack gap="md" align="center">
          <Title order={2} c="gray.7">
            Oops! We're Under the Hood
          </Title>
          <Text size="lg" c="dimmed" ta="center">
            Our servers are taking a quick coffee break. Don't worry - our team
            of digital mechanics is already on it!
          </Text>
          <Text size="sm" c="dimmed" ta="center">
            Please check back in a few minutes. ☕
          </Text>
        </Stack>
      </Stack>
    </FullScreenLayout>
  );
};
